import { styled } from '@mui/material/styles';

export const Thumbnail = styled('img')(() => ({
  width: '10rem',
  height: '10rem',
  borderRadius: '0.5rem',
  objectFit: 'cover',
}));
